import {
  getMediaCondition,
  mobileMediaQuery,
} from 'common/constants/mediaQueries'
import React from 'react'
import { DefaultTheme, useTheme } from 'styled-components'
import { WebsiteLogoImageUi } from '../ui'

export interface WebsiteLogoPictureProps {
  alt: string
  mobileImageSrc: string
  imageSrc: string
  height?: number
  mobileHeight?: number
}

export const WebsiteLogoPicture = ({
  alt,
  mobileImageSrc,
  imageSrc,
  height,
  mobileHeight,
}: WebsiteLogoPictureProps) => {
  const hasMobileImageSource = Boolean(
    mobileImageSrc && mobileImageSrc !== imageSrc,
  )
  return (
    <picture>
      {hasMobileImageSource && (
        <source media={mobileMediaQuery} srcSet={mobileImageSrc} />
      )}
      <WebsiteLogoImageUi
        src={imageSrc}
        alt={alt}
        imageSrc={imageSrc}
        mobileImageSrc={mobileImageSrc}
        height={height}
        mobileHeight={mobileHeight}
      />
    </picture>
  )
}
